import React, { useState } from "react";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import { getTime, getDay } from "./SettingsUtil";
import Input from "@amzn/meridian/input";
import { TableCell } from "@amzn/meridian/table";

const checkProcessExist = (data, plan, process) => {
  return data[plan] && data[plan][process] ? true : false;
};

export const TaskBreaksCell = (props) => {
  const plan = props.data.plan,
    process = props.data.cell,
    time = props.data.time,
    data = props.data.insights,
    stationTime = props.data.stationTime;

  const onChange = (value) => {
    if (!data[plan]) {
      data[plan] = {};
    }

    if (!checkProcessExist(data, plan, process)) {
      data[plan][process] = {
        startTime: {
          day: 0,
          time: "",
        },
        endTime: {
          day: 0,
          time: "",
        },
      };
    }

    let setTime = value ? value.format("HH:mm:ss") : "";
    let setDay = value ? getDay(value.format("HH:mm:ss"), stationTime) : 0;

    data[plan][process][time].formattedTime = setTime;
    data[plan][process][time].time = setTime;
    data[plan][process][time].day = setDay;
  };

  return checkProcessExist(data, plan, process) ? (
    <TableCell>
      <TimePicker
        showSecond={false}
        timeOnly={true}
        minuteStep={15}
        defaultValue={getTime(data[plan][process][time].time)}
        onChange={onChange}
      />{" "}
    </TableCell>
  ) : (
    <TableCell>
      <TimePicker
        showSecond={false}
        timeOnly={true}
        minuteStep={15}
        placeholder="Enter Time"
        onChange={onChange}
      />
    </TableCell>
  );
};

export const NodeTargetsCell = (props) => {
  const targetMap = props.data.targetMap,
    target = props.data.target,
    data = props.data.insights;

  const [value, setValue] = useState(
    checkProcessExist(data, targetMap, target) ? data[targetMap][target] : "",
  );

  const onChange = (value) => {
    if (!data[targetMap]) {
      data[targetMap] = {};
    }
    setValue(value);
    data[targetMap][target] = value ? Number(value) : undefined;
  };

  return checkProcessExist(data, targetMap, target) ? (
    <TableCell>
      <Input size="small" type="number" value={value} onChange={onChange} />
    </TableCell>
  ) : (
    <TableCell>
      <Input
        size="small"
        type="number"
        value={value}
        onChange={onChange}
        placeholder="Enter Val"
      />
    </TableCell>
  );
};



// WEBPACK FOOTER //
// ./src/components/settings/tableCellData.js